/* Spare polish (Sep 26)
   1. Product titles: the NDC and/or part number move out of the name into a small "exact box" line with a short explanation.
   2. Expiration: when there are 3+ dates, offer "Best price" and "Longest dating", with every date one tap away.
   3. Dating box: an exact expiration month shows as that month, not a date range.
   4. Subscribe & save: shows on product pages once a subscription app has added selling plans.
   5. Cart: how far the order is from free shipping.
*/
(function () {
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var NDC_RE = /^(.*?)\s*\|\s*NDC\s*([0-9‑\-]+)\s*$/;
  var PART_RE = /^(.*?)\s*\(([A-Za-z0-9]+(?:[‑\-][A-Za-z0-9]+)+)\)\s*$/;
  var EXPLAIN_PART = 'The maker’s part number from the box label. Most people can shop by the product name. If you need one exact box, like matching a past order, order by this number.';
  var EXPLAIN_NDC = 'The National Drug Code printed on the box. It pins down this exact product and box size. Match it to your current box if you want the very same item.';

  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function parseExp(v) {
    var m = String(v).match(/(\d{1,2})\/(\d{4})/);
    if (m) return { y: +m[2], m: +m[1] };
    m = String(v).match(/(20\d{2})/);
    return m ? { y: +m[1], m: 0 } : null;
  }
  function expLabel(e) { return e.m ? MONTHS[e.m - 1] + ' ' + e.y : String(e.y); }
  function expKey(e) { return e.y * 12 + (e.m || 1); }
  function cleanVariant(t) { return String(t).replace(/\s*\(month not recorded\)/i, ''); }

  function split(text) {
    var name = text, labels = [], explain = [];
    var m = name.match(NDC_RE);
    var ndc = null;
    if (m) { name = m[1]; ndc = 'NDC ' + m[2].replace(/‑/g, '-'); }
    m = name.match(PART_RE);
    if (m) { name = m[1]; labels.push('Part # ' + m[2].replace(/‑/g, '-')); explain.push(EXPLAIN_PART); }
    if (ndc) { labels.push(ndc); explain.push(EXPLAIN_NDC); }
    if (!labels.length) return null;
    return { name: name, label: labels.join(' · '), explain: explain.join(' ') };
  }

  function splitTitles() {
    document.querySelectorAll('.sp-pdp .sp-title, [data-spare-sticky-title]').forEach(function (el) {
      if (el.dataset.spSplit) return;
      var s = split(el.textContent.trim());
      if (!s) return;
      el.dataset.spSplit = '1';
      el.textContent = s.name;
      if (!el.classList.contains('sp-title')) return;
      var d = document.createElement('details');
      d.className = 'sp-ident';
      d.innerHTML = '<summary><span class="sp-ident__label"></span><span class="sp-ident__q">What’s this?</span></summary><p></p>';
      d.querySelector('.sp-ident__label').textContent = s.label;
      d.querySelector('p').textContent = s.explain;
      var sub = el.parentNode.querySelector('.sp-subtitle');
      (sub || el).after(d);
    });
    var t = split(document.title.replace(/\s+[–\-]\s+Spare$/, ''));
    if (t) document.title = t.name + ' – Spare';
  }

  function enhanceExpiration(root) {
    var dataEl = root.querySelector('[data-spare-variants]');
    var fs = root.querySelector('.sp-opt--exp');
    var input = root.querySelector('[data-spare-variant-input]');
    if (!dataEl || !fs || !input) return;
    var variants = JSON.parse(dataEl.textContent);
    var idx = parseInt(fs.getAttribute('data-spare-option'), 10);
    var row = fs.querySelector('.sp-opt__row');
    var labels = Array.prototype.slice.call(fs.querySelectorAll('.sp-opt__btn'));

    labels.forEach(function (l) {
      var n = l.querySelector('.sp-opt__name');
      var e = parseExp(l.querySelector('input').value);
      if (n && e) n.textContent = 'Exp ' + expLabel(e);
    });

    var quick = null, more = null, open = false;
    if (labels.length >= 3 && row) {
      quick = document.createElement('div');
      quick.className = 'sp-quick';
      more = document.createElement('button');
      more.type = 'button';
      more.className = 'sp-quick__more';
      row.parentNode.insertBefore(quick, row);
      row.parentNode.insertBefore(more, row);
      row.hidden = true;
      more.addEventListener('click', function () { open = !open; row.hidden = !open; paint(); });
    }

    function current() { return variants.find(function (v) { return String(v.id) === String(input.value); }) || variants[0]; }
    function choose(value) {
      var radio = labels.map(function (l) { return l.querySelector('input'); }).find(function (r) { return r.value === value; });
      if (!radio) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function options() {
      var cur = current();
      return labels.map(function (l) {
        var val = l.querySelector('input').value;
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return i === idx ? o === val : o === cur.options[i]; }); });
        return { value: val, exp: parseExp(val), v: v };
      }).filter(function (o) { return o.v && o.v.available && o.v.price > 0 && o.exp; });
    }

    function paint() {
      var cur = current();
      var sel = cur.options[idx];
      if (quick) {
        var list = options();
        quick.innerHTML = '';
        if (list.length) {
          var best = list.slice().sort(function (a, b) { return a.v.price - b.v.price || expKey(b.exp) - expKey(a.exp); })[0];
          var longest = list.slice().sort(function (a, b) { return expKey(b.exp) - expKey(a.exp) || a.v.price - b.v.price; })[0];
          var picks = best.value === longest.value ? [['Best price & longest dating', best]] : [['Best price', best], ['Longest dating', longest]];
          quick.classList.toggle('sp-quick--one', picks.length === 1);
          picks.forEach(function (p) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'sp-quick__btn';
            b.setAttribute('aria-pressed', p[1].value === sel ? 'true' : 'false');
            b.innerHTML = '<span class="sp-quick__title"></span><span class="sp-quick__sub"></span>';
            b.firstChild.textContent = p[0];
            b.lastChild.textContent = 'Exp ' + expLabel(p[1].exp) + ' · ' + money(p[1].v.price);
            b.addEventListener('click', function () { choose(p[1].value); });
            quick.appendChild(b);
          });
          var isQuick = picks.some(function (p) { return p[1].value === sel; });
          if (!isQuick && !open) { open = true; row.hidden = false; }
        }
        more.textContent = open ? 'Hide other dates' : 'See all ' + labels.length + ' expiration dates';
      }
      var e = parseExp(sel);
      var box = root.querySelector('[data-spare-dating-for="' + cur.id + '"]');
      if (e && box) {
        var start = new Date(e.y, (e.m || 1) - 1, 1);
        var months = Math.floor((start - new Date()) / (30.44 * 864e5));
        if (months >= 1) {
          box.innerHTML = '<span class="sp-facts__big"></span><span style="font-size:14px;font-weight:600;color:var(--sp-ink)"></span>';
          box.firstChild.textContent = e.m ? 'Expires ' + expLabel(e) : 'Expires in ' + e.y;
          box.lastChild.textContent = 'At least ' + months + ' month' + (months === 1 ? '' : 's') + ' from today';
        }
      }
      var sticky = root.querySelector('[data-spare-sticky-sub]');
      if (sticky) sticky.textContent = cleanVariant(sticky.textContent);
    }

    root.addEventListener('change', function () { setTimeout(paint, 0); });
    paint();
  }

  function subscriptions(root) {
    var el = document.getElementById('SpareSellingPlans');
    var input = root.querySelector('[data-spare-variant-input]');
    var price = root.querySelector('.sp-price');
    if (!el || !input || !input.form || !price) return;
    var data = JSON.parse(el.textContent);
    var hidden = document.createElement('input');
    hidden.type = 'hidden'; hidden.name = 'selling_plan'; hidden.value = '';
    input.form.appendChild(hidden);
    var box = document.createElement('fieldset');
    box.className = 'sp-sub';
    price.parentNode.insertBefore(box, price);
    var choice = data.requires ? 'plan' : 'once';
    var planId = null;

    box.addEventListener('change', function (e) {
      if (e.target.name === 'spare-buy-type') choice = e.target.value;
      if (e.target.name === 'spare-plan') { planId = e.target.value; choice = 'plan'; }
    });

    function paint() {
      var vid = String(input.value);
      var allocs = data.variants[vid] || [];
      var once = data.prices[vid];
      if (!allocs.length) { box.hidden = true; hidden.value = ''; return; }
      box.hidden = false;
      if (!allocs.some(function (a) { return String(a.plan) === String(planId); })) planId = allocs[0].plan;
      var a = allocs.find(function (x) { return String(x.plan) === String(planId); });
      var off = once > a.price ? Math.round((1 - a.price / once) * 100) : 0;
      box.innerHTML =
        '<legend class="sp-eyebrow">How you want it</legend>' +
        (data.requires ? '' : '<label class="sp-sub__opt"><input type="radio" name="spare-buy-type" value="once"' + (choice === 'once' ? ' checked' : '') + '><span><strong>One time</strong><span class="sp-sub__price">' + money(once) + '</span></span></label>') +
        '<label class="sp-sub__opt"><input type="radio" name="spare-buy-type" value="plan"' + (choice === 'plan' ? ' checked' : '') + '><span><strong>Subscribe &amp; save' + (off ? ' ' + off + '%' : '') + '</strong><span class="sp-sub__price">' + money(a.price) + '</span></span>' +
        '<span class="sp-sub__fine">Refills ship on your schedule. Skip, change or cancel anytime.</span></label>' +
        (allocs.length > 1 ? '<select class="sp-sub__select" name="spare-plan" aria-label="How often">' + allocs.map(function (x) { return '<option value="' + x.plan + '"' + (String(x.plan) === String(planId) ? ' selected' : '') + '></option>'; }).join('') + '</select>' : '');
      box.querySelectorAll('.sp-sub__select option').forEach(function (o, i) { o.textContent = allocs[i].name; });
      hidden.value = choice === 'plan' ? a.plan : '';
      root.querySelectorAll('[data-spare-price]').forEach(function (p) { p.textContent = money(choice === 'plan' ? a.price : once); });
    }
    root.addEventListener('change', function () { setTimeout(paint, 0); });
    paint();
  }

  var shipTimer = null;
  function freeShipping() {
    var goal = window.SPARE_FREE_SHIP_CENTS;
    var hosts = document.querySelectorAll('.cart-drawer__summary, .cart-summary, .cart__summary');
    if (!goal || !hosts.length) return;
    clearTimeout(shipTimer);
    shipTimer = setTimeout(function () {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-drawer__summary, .cart-summary, .cart__summary').forEach(function (h) {
          var bar = h.querySelector('.sp-ship');
          if (!bar) {
            bar = document.createElement('div');
            bar.className = 'sp-ship';
            bar.innerHTML = '<span class="sp-ship__text"></span><span class="sp-ship__track"><span class="sp-ship__fill"></span></span>';
            h.insertBefore(bar, h.firstChild);
          }
          var left = goal - cart.total_price;
          bar.querySelector('.sp-ship__text').textContent = !cart.item_count ? '' : (left > 0 ? money(left) + ' away from free shipping' : 'Free standard shipping on this order');
          bar.querySelector('.sp-ship__fill').style.width = Math.min(100, Math.round((cart.total_price / goal) * 100)) + '%';
          bar.hidden = !cart.item_count;
        });
      }).catch(function () {});
    }, 250);
  }

  function boot() {
    splitTitles();
    document.querySelectorAll('[data-spare-product]').forEach(function (root) {
      try { enhanceExpiration(root); } catch (e) {}
      try { subscriptions(root); } catch (e) {}
    });
    freeShipping();
    document.addEventListener('cart:update', freeShipping);
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && t.closest('.sp-ship')) continue;
        if (t.closest && t.closest('cart-drawer-component, .cart-drawer, .cart-summary, .cart__summary, [class*="cart-drawer"]')) { freeShipping(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else setTimeout(boot, 0);
})();